import * as React from 'react';

// API
import apibridge from '../../apibridge';

// REDUX
import { useAppSelector } from '../../store';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as DocumentIcon } from '../../assets/svg/document.svg';

// TYPES
import { ComplaintComplaintAdviceDocument } from '../../api/models';

const ComplaintsAdviceTemplates: React.FC = () => {
	// Get Website Url from Redux store
	const websiteUrl = useAppSelector((state) => state.lists.websiteUrl);

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	// State to hold fetch data
	const [complaintsAdviceData, setComplaintsAdviceData] = React.useState<ComplaintComplaintAdviceDocument[]>([]);

	const getComplaintsAdviceData = async () => {
		setIsLoading(true);

		const response = await apibridge.getComplaintsAdviceData();

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			const { result = [] } = response;

			setIsLoading(false);

			setComplaintsAdviceData(result);
		}
	};

	React.useEffect(() => {
		getComplaintsAdviceData();
	}, []);

	return (
		<div className="page-general-layout complaints-page">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								{complaintsAdviceData && complaintsAdviceData.length > 0 ? (
									<section className="info-section">
										<div className="section-header">
											<h2 className="header-name color-dark">Documents</h2>
										</div>

										<ul>
											{complaintsAdviceData.map((item) => {
												return (
													<li key={item.id} className="row-container">
														<div className="row detail-row">
															<div className="col-auto pdl-0 pdr-0 icon-box">
																<DocumentIcon />
															</div>

															<div className="col-md-auto full-width">
																<div className="row detail-info complaint-page">
																	<div className="col-12 detail-name">{item.title}</div>
																</div>
															</div>

															<div className="col-auto pdr-0 link-group">
																{item && item.attachmentUrl && (
																	<a className="btn-text mtop-0 pdr-0" href={item.attachmentUrl} download>
																		Download
																	</a>
																)}
															</div>
														</div>
													</li>
												);
											})}
										</ul>
									</section>
								) : (
									<div className="detail-prompt">
										Information in this section is coming soon. In the meantime feel free to{' '}
										<a href={`${websiteUrl}/contact-us`} target="_blank">
											contact us
										</a>
										.
									</div>
								)}
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ComplaintsAdviceTemplates;
